import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";
//Redux
import { Provider } from "react-redux";
import { persistor, store } from "./store";
import { PersistGate } from "redux-persist/integration/react";

import "./index.scss";
import reportWebVitals from "./reportWebVitals";
import routes from "./routes";
import { ConfigProvider } from "antd";
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { onahAntdTheme } from "config/antdConfig";
import { FullLoader } from "components/Loader";
import 'react-lazy-load-image-component/src/effects/blur.css';
import ErrorBoundary from "boundary";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <ConfigProvider theme={onahAntdTheme}>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <Suspense fallback={<FullLoader/>}>
              <RouterProvider
                router={routes}
                fallbackElement={<div>loading...</div>}
              />
            </Suspense>
          </PersistGate>
        </Provider>
        <ToastContainer icon={false} hideProgressBar pauseOnFocusLoss={false} pauseOnHover={false} limit={5} newestOnTop   />
      </ConfigProvider>
    </ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
